import React, { Dispatch, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { Col, Form, Image, Row } from 'react-bootstrap';
import { useUser } from '../../../../Context/UserContext';
import { startGuidedTourAtom } from '../../Atoms/vtsAtoms';
import UserRewards from './UserRewards/UserRewards';
//@ts-ignore
import styles from './AccountContent.module.scss?module';

type AccountContentPropsT = {
  setShowAccount: Dispatch<boolean>;
};

const AccountContent: FC<AccountContentPropsT> = ({ setShowAccount }) => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [isGuidedTourStarted, setIsGuidedTourStarted] =
    useAtom(startGuidedTourAtom);

  function startGuidedTour() {
    if (user && user.id) {
      navigate('/virtual-trade-show/lobby');
      setShowAccount(false);
      setIsGuidedTourStarted(true);
    }
  }

  return (
    <>
      <p className={'text-muted'}>
        Among all visitors, we will reward the most interactive ones for their
        level of participation in the Virtual Trade Show.
        <br />
        For each activity shown in the account overview, you will earn points.
        <br />
        With the total count of collected points, you will compete with all
        visitors for the chance to win a brand new Apple iPhone 17!
      </p>

      <Form.Switch
        checked={isGuidedTourStarted}
        onChange={startGuidedTour}
        label="Show the guided tour"
        className={`${styles.GuidedTourSwitcher} py-3`}
      />

      <UserRewards />
      <Row className={'pt-3'}>
        <Col
          xs={3}
          className={'d-flex flex-column justify-content-center'}
        ></Col>
        <Col xs={6}>
          <Image
            className={'w-100'}
            src={
              'https://files.naskorsports.com/shop/virtual-trade-show/vts-2026-prize.png'
            }
          />
        </Col>
        <Col
          xs={3}
          className={'d-flex flex-column justify-content-center'}
        ></Col>
      </Row>
    </>
  );
};

export default AccountContent;
